import script from "./app-channel.vue?vue&type=script&setup=true&lang=js"
export * from "./app-channel.vue?vue&type=script&setup=true&lang=js"

import "./app-channel.vue?vue&type=style&index=0&id=06ca89c3&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ca89c3"]])

export default __exports__